import {connect} from '../../app/connect';
import TemplateEditForm from './TemplateEditForm';
import {actions as formActions} from 'react-redux-form';
import {
  getPendingTemplate,
  getPendingTemplateForm,
  getPendingTemplateFormAttributes,
  getIssueAttributesMappingEntitiesMap,
  getIssueTypesAdminEntitiesMap,
  getGroupedProjectActiveEntities,
  getActiveUsers,
  getIssueAttributesDefinitionsEntitiesMap,
  getCurrentDuplicateTemplateId,
  getTemplateCategoriesEntitiesMap,
  getDefaultIssueSubtypeId,
  getIssueRootCausesDefinitionsEntitiesMap
} from '../../app/selectors';
import {doesTemplateCategoryAllowTemplateToToggleIsActive} from '../../utils/issue-template-helpers';

const mapStateToProps = state => {
  const pendingTemplate = getPendingTemplate(state);
  const canToggleIsActive = doesTemplateCategoryAllowTemplateToToggleIsActive(
    pendingTemplate,
    getTemplateCategoriesEntitiesMap(state)
  );

  return {
    pendingTemplate,
    pendingTemplateFormAttributes: getPendingTemplateFormAttributes(state),
    pendingTemplateForm: getPendingTemplateForm(state),
    issueCustomAttributesMappings: getIssueAttributesMappingEntitiesMap(state),
    fieldIssueTypeEntitiesMap: getIssueTypesAdminEntitiesMap(state),
    groupedProjectEntities: getGroupedProjectActiveEntities(state),
    users: getActiveUsers(state),
    issueCustomAttributes: getIssueAttributesDefinitionsEntitiesMap(state),
    focusTitle: !!getCurrentDuplicateTemplateId(state),
    canToggleIsActive,
    defaultIssueSubtypeId: getDefaultIssueSubtypeId(state),
    templateCategoriesEntitiesMap: getTemplateCategoriesEntitiesMap(state),
    rootCauseEntitiesMap: getIssueRootCausesDefinitionsEntitiesMap(state)
  };
};

const {change: changeFormValueAction, setErrors: setErrorsFormAction} = formActions;

const mapDispatchToProps = {
  changeFormValueAction,
  setErrorsFormAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  undefined,
  {forwardRef: true}
)(TemplateEditForm);
